export default __webpack_public_path__ + "static/media/ash-comments-icon.06efc889.svg";